import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

import { canMascaradeAsQuery, getAllRolesQuery } from "./queries";
import { formatRoles } from "constants/forms";

const RightsContext = createContext({});

export const useRightsContext = () => useContext(RightsContext);

export const RightsProvider = ({ ...props }) => {
  const [roleList, setRoleList] = useState([]);
  const [canMascarade, setCanMascarade] = useState(false);

  const getAllRoles = useCallback(
    async (roles) => {
      try {
        const result = await getAllRolesQuery(roles);
        setRoleList(formatRoles(result));
      } catch (e) {
        console.error("getAllRoles", e);
      }
    },
    [roleList]
  );

  const canMascaradeAs = useCallback(
    async (email) => {
      try {
        const result = await canMascaradeAsQuery(email);
        setCanMascarade(result);
      } catch (e) {
        console.error("canMascaradeAs", e);
      }
    },
    [canMascarade]
  );

  const values = useMemo(
    () => ({
      canMascarade,
      canMascaradeAs,
      setCanMascarade,
      roleList,
      getAllRoles,
    }),
    [roleList, canMascarade, canMascaradeAs, setCanMascarade, getAllRoles]
  );
  return <RightsContext.Provider value={values} {...props} />;
};
